// extracted by mini-css-extract-plugin
export default {"storeContainer":"StoreFront_storeContainer__2PJDg","topFlexDiv":"StoreFront_topFlexDiv__AoTZ2","innerContainer":"StoreFront_innerContainer__np4+a"};